import { render, staticRenderFns } from "./Duels_Challenge_Post.vue?vue&type=template&id=0dd42827&scoped=true&"
import script from "./Duels_Challenge_Post.vue?vue&type=script&lang=js&"
export * from "./Duels_Challenge_Post.vue?vue&type=script&lang=js&"
import style0 from "./Duels_Challenge_Post.vue?vue&type=style&index=0&id=0dd42827&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd42827",
  null
  
)

export default component.exports